"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformPropVal = void 0;
function transformPropVal(val, mapper) {
    if (val === undefined || val === null) {
        return val;
    }
    if (Array.isArray(val)) {
        return val.map(col => {
            if (col === undefined || col === null) {
                return col;
            }
            return mapper(col);
        });
    }
    return mapper(val);
}
exports.transformPropVal = transformPropVal;
//# sourceMappingURL=transformPropVal.js.map